import React from 'react';
import { useTranslation } from 'react-i18next';

export default function GlobalFooter() {
  const { t } = useTranslation('translation');

  return (
    <div className="global-footer" sx={{ position: 'absolute', bottom: 0 }}>
      <footer id="wb-info">
        <div className="landscape">
          <nav className="container wb-navcurr">
            <h2 className="wb-inv">{t("About government")}</h2>
            <ul className="list-unstyled colcount-sm-2 colcount-md-3">
              <li><a href="http://contact-contactez.nrcan-rncan.gc.ca/index.cfm?lang=eng&amp;context=[current-page:url:args:first]">{t("Contact us")}</a></li>
              <li><a href="https://www.canada.ca/en/government/dept.html">{t("Departments and agencies")}</a></li>
              <li><a href="https://www.canada.ca/en/government/publicservice.html">{t("Public service and military")}</a></li>
              <li><a href="https://www.canada.ca/en/news.html">{t("News")}</a></li>
              <li><a href="https://www.canada.ca/en/government/system/laws.html">{t("Treaties, laws and regulations")}</a></li>
              <li><a href="https://www.canada.ca/en/transparency/reporting.html">{t("Government-wide reporting")}</a></li>
              <li><a href="https://pm.gc.ca/en">{t("Prime Minister")}</a></li>
              <li><a href="https://www.canada.ca/en/government/system.html">{t("About government")}</a></li>
              <li><a href="https://open.canada.ca/en">{t("Open government")}</a></li>
            </ul>
          </nav>
        </div>
        <div className="brand">
          <div className="container">
            <div className="row">
              <nav className="col-md-9 col-lg-10 ftr-urlt-lnk">
                <h2 className="wb-inv">{t("About this site")}</h2>
                <ul>
                  <li><a href="https://www.canada.ca/en/social.html">{t("Social media")}</a></li>
                  <li><a href="https://www.canada.ca/en/mobile.html">{t("Mobile applications")}</a></li>
                  <li><a href="https://www.canada.ca/en/government/about.html">{t("About Canada.ca")}</a></li>
                  <li><a href="https://www.nrcan.gc.ca/terms-and-conditions/10847">{t("Terms and conditions")}</a></li>
                  <li><a href="https://www.canada.ca/en/transparency/privacy.html">{t("Privacy")}</a></li>
                </ul>
              </nav>
              <div className="col-xs-6 visible-sm visible-xs tofpg">
                <a href="#wb-cont">{t("Top of Page")} <span className="glyphicon glyphicon-chevron-up"></span></a>
              </div>
              <div className="col-xs-6 col-md-3 col-lg-2 text-right">
                <img src="https://wet-boew.github.io/themes-dist/GCWeb/GCWeb/assets/wmms-blk.svg" alt={t("Symbol of the Government of Canada")} />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
